import Service from '@ember/service';
import { service } from '@ember/service';
import type CdpService from '../services/cdp';
import type LoggingService from '../services/logger';
import type ModelService from '../services/model';
import type { OpAmpSpec } from '../services/model';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type DataService from './data';
import type { SpicePartData, CfbData } from './data';

import type { DatabookStore } from '@ebiz/aditools-databook';

export default class OpampService extends Service {
  @service('aditools-site') declare siteconfig: SiteService; //{ [key: string]: string };
  @service('model') declare modelService: ModelService;
  @service declare cdp: CdpService;
  @service declare logger: LoggingService;
  @service declare data: DataService;
  opAmps?: Promise<OpAmpSpec[] | null>;
  databook?: DatabookStore;
  // Load the opamps from cdp

  load(config?: Promise<PhotodiodeConfigJson | null>): void {
    if (config) {
      // Capture service references before async operations to prevent "owner destroyed" errors
      const dataService = this.data;
      this.opAmps = config.then(async (cfg) => {
        if (cfg === null) return cfg;
        const { databook, opAmp } = await dataService.load(config);
        this.databook = databook;
        return opAmp
          .filter((item) => {
            // Remove currrent feedback parts without cfb data in the json
            return item.feedbackMethod !== 'Current' || item.cfb;
          })
          .map((item) => {
            return {
              partNumber: item.partNumber as string,
              gbw: parseFloat(item.gbw as string),
              slewRate: parseFloat(item.slewRate as string),
              rOut: parseFloat(item.rOut as string),
              supplyCurrent: parseFloat(item.supplyCurrent as string),
              iNoise: parseFloat(item.iNoise as string),
              vNoise: parseFloat(item.vNoise as string),
              outHeadroomPlus: parseFloat(item.outHeadroomPlus as string),
              outHeadroomMinus: parseFloat(item.outHeadroomMinus as string),
              inHeadroomPlus: parseFloat(item.inHeadroomPlus as string),
              inHeadroomMinus: parseFloat(item.inHeadroomMinus as string),
              feedbackMethod: item.feedbackMethod as string,
              architecture: item.architecture as string,
              minSupplyVoltage: parseFloat(item.minSupplyVoltage as string),
              maxSupplyVoltage: parseFloat(item.maxSupplyVoltage as string),
              numberChannels: parseInt(item.numberChannels as string),
              packageCode: item.packageCode as string,
              minStableGain: parseFloat(item.minStableGain as string),
              iBias: parseFloat(item.iBias as string),
              vos: parseFloat(item.vos as string),
              cCm: parseFloat(item.cCm as string),
              cDiff: parseFloat(item.cDiff as string),
              vintage: parseInt(item.vintage as string),
              statusText: item.statusText as string,
              deviceStatus: parseInt(item.deviceStatus as string),
              price: parseFloat(item.price as string),
              tempRange: item.tempRange as string,
              spice: item.spice !== undefined && item.spice === 'Yes',
              cfb: item.cfb as CfbData,
              spiceModels: item.spiceModels as SpicePartData,
              polesZeroes: item.polesZeroes as PolesZeroesDetails,
              generic: item.generic as string,
              cfint: parseFloat((item.partNumber == 'ADA4351-2' ? '3e-12' : '0') as string),
            };
          });
      });
    }
  }
}
